var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1158,
    height: 464,
    viewBox: "0 0 1158 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1157.61 55.7002C1157.58 170.626 1157.52 285.526 1157.52 400.424C1150.91 400.798 1131.5 403.235 1116.53 419.891C1101.56 436.466 1101.11 456.094 1101.56 463.884C930.568 463.912 759.57 463.937 588.575 463.965V0.0576291H639.505C736.061 0.0576291 832.592 0.0300048 929.149 0.00488281C988.029 0.032517 1046.94 0.0576291 1105.82 0.0576291C1106.41 6.37831 1108.93 22.7377 1122.34 37.0371C1135.22 50.6909 1150.56 54.522 1157.61 55.7002Z",
    fill: "url(#paint0_linear_11_3531)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0975 0.0602596C96.9805 0.0627718 163.862 0.0652607 230.745 0.0677729C297.506 0.0451631 364.266 0.0226098 431.027 0C483.685 0.0301464 536.342 0.0602608 589 0.0929193C588.976 154.693 588.953 309.294 588.929 463.897C403.462 463.932 217.996 463.965 32.5295 464C32.2186 460.36 30.4589 442.895 19.6956 430.691C11.7343 421.665 3.24498 420.504 0.0625553 420.303C0.0521326 413.1 0.0417005 405.898 0.0312777 398.695C2.16968 394.877 7.86051 383.688 8.45982 367.165C9.18594 347.123 1.90907 333.27 0.02428 329.889C1.92817 326.402 9.25199 312.165 8.33131 291.822C7.61214 275.897 2.23744 265.024 0.0399718 261.027C1.77015 258.59 9.66889 246.939 10.1188 228.293C10.6208 207.545 1.51125 194.266 0.0155858 192.155C1.91079 188.832 8.7586 176.024 8.58662 157.01C8.42159 138.889 1.98897 126.745 0.02428 123.301C1.47131 121.007 8.0412 110.107 7.82058 93.4864C7.61387 77.8731 1.55647 67.7363 0 65.2794C0.0208456 58.0468 0.0434062 50.8141 0.0642518 43.5815C2.46149 43.4257 12.3736 42.3908 20.6545 30.7016C29.3037 18.4873 30.0002 3.35626 30.0975 0.0602596Z",
    fill: "url(#paint1_linear_11_3531)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.6 35.8718H81.783C55.2466 35.8718 33.7723 57.3737 33.7723 83.9101V377.518C33.7723 404.027 55.2466 425.529 81.783 425.529H1075.6C1102.14 425.529 1123.61 404.027 1123.61 377.518V83.9101C1123.61 57.3737 1102.14 35.8718 1075.6 35.8718ZM1114.56 371.597C1114.56 395.427 1095.26 414.734 1071.45 414.734H85.8803C62.0773 414.734 42.7711 395.427 42.7711 371.597V89.7207C42.7711 65.8901 62.0773 46.5838 85.8803 46.5838H1071.45C1095.25 46.5838 1114.56 65.8901 1114.56 89.7207V371.597Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_3531",
    x1: 873.09,
    y1: 0.00488281,
    x2: 873.09,
    y2: 463.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#CCCCCC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11_3531",
    x1: 294.5,
    y1: 0,
    x2: 294.5,
    y2: 464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribe);
export default __webpack_public_path__ + "static/media/Subscribe.088f1a5609e7be26387621f14f5054dc.svg";
export { ForwardRef as ReactComponent };